import angular from 'angular';

import { MERCHANT_PORTAL_API_BASE_URL } from '../../core/main/controller/environment';

angular.module("merchant.application.main").factory("merchant.application.main.factory.merchantAdmin", [
    "$resource",
    function($resource) {

        var base = MERCHANT_PORTAL_API_BASE_URL + "/portal/merchants/:merchantId/shops";
        var endpointShopList = base;
        var endpointUpdateShopConfig = base + "/:shopId/config";

        var resourceShopList = $resource(endpointShopList);
        var resourceUpdateShopConfig = $resource(endpointUpdateShopConfig);

        var expose = {};

        expose.readShopList = function(parameters, success, error) {
            resourceShopList.query(parameters, success, error);
        };

        expose.updateShopConfiguration = function(parameters, urlParameters, success, error) {
            new resourceUpdateShopConfig(parameters)
                .$save(urlParameters, success, error);
        };

        return expose;
    }
]);
